import { fetchData } from '../utils';
import { ApiResponse } from '../types';
import { OFFLINE } from './setup';

export const getCopyLengths = async () => {
  return fetchData<ApiResponse<number[]>>(`/${OFFLINE}/copy-lengths`);
};
